export default "__VITE_ASSET__DfN7jc4k__"